import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import Image from '../../../components/image/Image';
import MaxWidthWrapper from '../../../components/max-width-wrapper/MaxWidthWrapper';
import ThemeContainer from '../../../components/theme-container/ThemeContainer';
import { BodyText, PageTitle } from '../../../components/typography/Heading';
import { formatMoneyKr } from '../../../utils';
import { THEMES } from '../../../utils/cms-utils';
import styles from './total-collected-tva.module.less';

const TotalCollectedTva = () => {
    const [totalCollected, setTotalCollected] = useState(0);
    const baseUrl = useSelector((state) => state.baseURL);
    const events = [
        useSelector((state) => state.campaigns.p3aEventId),
        useSelector((state) => state.campaigns.tvaEventId),
    ];
    const componentIsMounted = useRef(true);
    useEffect(() => {
        return () => {
            componentIsMounted.current = false;
        };
    }, []);
    useEffect(() => {
        fetch(`${baseUrl}/api/public/project/event/stats?${events.map((e) => 'eventId=' + e).join('&')}`)
            .then((response) => response.json())
            .then((json) => {
                if (componentIsMounted.current) {
                    setTotalCollected(json.collectedAmount);
                }
            });
    }, []);
    return (
        <ThemeContainer mainColor={THEMES.BLUE} className={styles.container}>
            <MaxWidthWrapper className={styles.wrapper}>
                <Image className={styles.leftImage} src={'campaign/tva2023/tva-stats-venstre.svg'} />
                <div className={styles.textContainer}>
                    <PageTitle tag={'span'} className={styles.totalCollected}>
                        {formatMoneyKr(totalCollected)}
                    </PageTitle>
                    <BodyText className={styles.description}>
                        Totalt innsamlet til <span className={styles.tva}>TV-aksjonen</span> på Spleis
                    </BodyText>
                </div>
                <Image className={styles.rightImage} src={'campaign/tva2023/tva-stats-høyre.svg'} />
            </MaxWidthWrapper>
        </ThemeContainer>
    );
};

export default TotalCollectedTva;
